import useTranslation from "../../hooks/useTranslation";
import { Modal, type ModalProps } from "../../lib/modal";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

enum ModalVariant {
  GenericError,
  PaymentInfoUpdateSuccess,
  PaymentInfoUpdateFinished,
}

const WithVariant = (variant: ModalVariant) => {
  const ModalWithVariant = ({ open, onClose, telemetryName }: Omit<ModalProps, "children">) => {
    const { t, m } = useTranslation();

    let title: string;
    let description: React.ReactNode;

    switch (variant) {
      case ModalVariant.PaymentInfoUpdateSuccess:
        title = t(m.PaymentInfoModal.SuccessTitle);
        description = t(m.PaymentInfoModal.SuccessDescription);
        break;
      case ModalVariant.PaymentInfoUpdateFinished:
        title = "";
        description = t(m.PaymentInfoModal.FinishedDescription);
        break;
      case ModalVariant.GenericError:
      default:
        title = t(m.ErrorMessage.SomethingWentWrong);
        description = t(m.PaymentInfoModal.ErrorDescription, {
          link: (chunks) => <NewZendeskTicketLink>{chunks}</NewZendeskTicketLink>,
        });
        break;
    }

    return (
      <Modal open={open} onClose={onClose} telemetryName={telemetryName} title={title}>
        <div>{description}</div>
      </Modal>
    );
  };
  return ModalWithVariant;
};

export const GenericErrorModal = WithVariant(ModalVariant.GenericError);
export const PaymentInfoUpdateSuccessModal = WithVariant(ModalVariant.PaymentInfoUpdateSuccess);
export const PaymentInfoUpdateFinishedModal = WithVariant(ModalVariant.PaymentInfoUpdateFinished);
